import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

export type MobileNavAction = 'dashboard' | 'menu' | 'search' | 'notifications' | 'profile';

/**
 * Small screens: main navigation shortcuts (bottom nav of the menu top) requested from elsewhere,
 * e.g. the edit view "Plus" sheet while the bottom nav is hidden. Handled by the menu top.
 */
@Injectable({ providedIn: 'root' })
export class MobileNavService {
  readonly #actions = new Subject<MobileNavAction>();
  readonly actions$ = this.#actions.asObservable();
  /** Unread notifications count, published by the menu top (badge of the shortcuts). */
  readonly nbNotifications = signal(0);

  trigger(action: MobileNavAction): void {
    this.#actions.next(action);
  }
}
